module.exports = __webpack_public_path__ + "img/nissenren.f88e1349.png";